import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ActivateBreadcrumb } from 'src/app/store/actions/breadcrumb.actions';
import { BreadcrumbItem, breadcrumbs } from 'src/app/store/reducer/breadcrumb.reducer';

@Component({
    standalone: false,
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent {
    breadcrumbs$ = this.store.select(breadcrumbs);

    constructor(
        private store: Store,
        private router: Router
    ) {}

    activate(breadcrumb: BreadcrumbItem): void {
        this.store.dispatch(ActivateBreadcrumb({ breadcrumb, currentRoute: this.router.url }));
    }

    getPrevious(breadcrumbs: BreadcrumbItem[]) {
        if (breadcrumbs.length === 0) {
            return [];
        }

        return breadcrumbs.slice(0, breadcrumbs.length - 1);
    }

    getCurrent(breadcrumbs: BreadcrumbItem[]) {
        if (breadcrumbs.length === 0) {
            return [];
        }

        return breadcrumbs[breadcrumbs.length - 1];
    }
}
